import { render, staticRenderFns } from "./labour-service.vue?vue&type=template&id=bf866f50&scoped=true"
import script from "./labour-service.vue?vue&type=script&lang=js"
export * from "./labour-service.vue?vue&type=script&lang=js"
import style0 from "./labour-service.vue?vue&type=style&index=0&id=bf866f50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf866f50",
  null
  
)

export default component.exports